<!--
     <GenericExplorer
     />
-->

<template>
  <div v-if="apply_filters" class="generic-explorer-cont">
    
    <!-- VIEW HEADER -->
    <div >
    <ExplorerHeader2
      v-if="!headless"
      :title="title || bp_title"
      :disable="disabled || (loading == current_view)"
      :filters="apply_filters"
      :qunits="qunits"
      :views="avaible_views(views)"
      :view="current_view"
      :props="view_props"
      :filter_list="view_props.filter_list"
      :hide_add_button="hide_add_button"
      @update="update_filters"
      @update_props="update_props"
      @change_view="change_view"
      @update_qunits="update_qunit"
    >
      <template v-slot:after-title>
        <slot name="after-title"></slot>
      </template>
      <template v-slot:extra-header>
        <slot name="extra-header"></slot>
      </template>
    </ExplorerHeader2>
  </div>
      
    <div
      class="pl-3 pr-3 pt-0"
      :class="is_mobile ? 'genericexplorer-view-content' : 'genericexplorer-view-content-mobile'" :disabled="disabled"
    >
      <div>
        <slot name="left-panel" class="genericexplorerview-directory-cont">
          <SidePanel
            v-if="filters  && filters.get_filter_value('business_process') == 'DOCISODEFAULT'"
            :filters="apply_filters"
            :items="left_panel_items"
            @update_filters="update_filters"
          ></SidePanel>
        </slot>
      </div>
      <div class="genericexplorer-table-layout overflow-auto">
        <slot name="content_view" style="overflow: auto;">
          <!-- VIEW -->
          <component 
            class="genericexplorer-table-cont overflow-auto"
            v-if="current_view"
            :key="current_view+'_'+force_render"
            :is="current_view"
            :disabled="disabled"

            :view_props="view_props"
            :filters="apply_filters"
            :qunits="qunits"
            :already_selected="selected"
            :is_mobile="is_mobile"
            :loading="loading"

            @update="refresh"
            @update_filters="update_filters"
            @update-qunit="update_qunit"
            @update_props="update_props"
            @reset_filters="pull_filters"
            @clear_units="clear_qunits"
            @click="qunit_clicked"
            @navigate_to="goto_qunit"
            @select_all="select_all"
            @update_selection="update_selection"
            
            align="center"
          >
            
            <!-- VIEW FOOTER -->
            <template v-slot:footer>
              <QPagination
                v-if="qunits"
                :max_visible_buttons="3"
                :current_page="apply_filters.get_filter_value('page')"
                :total_units="qunits.count"
                allow_change_items_per_page
                :items_per_page="apply_filters.get_filter_value('units_per_page')"
                :units_length="qunits.length"
                :disabled="disabled"
                @page_changed="change_page"
                @items_per_page_changed="change_units_per_page"
              />
            </template>

            <!-- VIEW LOADING -->
            <template v-slot:loading>
              <v-row v-if="loading" align="center" justify="center" no-gutters>
                <v-progress-linear
                  v-if="qunits && qunits.length"
                  indeterminate
                  color="primary"
                />
                <v-progress-circular
                  v-else
                  indeterminate
                  color="primary"
                  class="mt-5 qmkey-progress-circular"
                />
              </v-row>
            </template>

            <!-- VIEW NO DATA -->
            <template v-slot:no-data>
              <div
                v-if="!(qunits && qunits.length) && !loading"
                class="mt-5"
              >
                {{ $vuetify.lang.translator('explorer.no_data') }}
              </div>
            </template>
          </component>

          <!-- NO VIEWS -->
          <v-container v-else>
            <v-row align="center" justify="center">
              <div
                class="mt-5"
              >
                {{ $vuetify.lang.translator('explorer.no_views') }}
              </div>
            </v-row>
          </v-container>
          
        </slot>
      </div>
    </div>
    <MobileQUnitView
      ref="qunit_view"
      :unit="clicked_qunit"
      @update-qunit="update_qunit"
      actions
      logo
      card
      tabs
      inline
    />
  </div>
</template>
  
  
<style lang="scss">
  .generic-explorer-cont {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .genericexplorer-table-layout {
    display: flex;
    flex-direction: rows;
    width: 100%;
  }

  .genericexplorer-table-cont {
    width: 100%;
  }
  .qmkey-progress-circular {
    align-self: center;
  }
  .genericexplorer-view-content {
    display: block;
    align-items: normal;
  }
  .genericexplorer-view-content-mobile {
    display: flex;
    align-items: flex-start;
  }
</style>
  
  
<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import axios from 'axios'
  import QUnitCollection from '@/qunit/QUnitCollection'
  import ExplorerHeader2 from '@/components/explorer/ExplorerHeader2'
  import ExplorerTable from '@/components/explorer/table/TableTable'
  import ExplorerCalendar from '@/components/explorer/ExplorerCalendar';
  import ExplorerCard from '@/components/explorer/ExplorerCardList'
  import MobileQUnitView from '@/components/explorer/MobileQUnitView';
  import ExplorerDirectory from '@/components/explorer/ExplorerDirectory';
  import ExplorerDirectoryMobile from '@/components/explorer/ExplorerDirectoryMobile';
  import SidePanel from '@/components/SidePanel.vue'
  import ExplorerCharts from '@/components/explorer/ExplorerCharts';
  import QPagination from '@/components/QPagination';
  import { QFilters, get_qfilter } from '@/qunit/filters';
  import Navegation from '@/utils/Navegation';
  import QUnit from '@/api/QUnit';
  export default {
    name: 'GenericExplorer',
  
    props: {
      title: String,
      //[{name: 'ExplorerTable',props},{name: 'ExplorerCalendar',props},'ExplorerCard': {props},'ExplorerCharts': {props}]
      views: {default: () => ([])},
      filters: {},
      items_to_select: {default: () => ([])},
      is_mobile: Boolean,
      hide_add_button: Boolean,
      headless: Boolean,
      state: Object,
      disabled: Boolean,
    },
  
    components: {
      ExplorerHeader2,
      ExplorerTable,
      ExplorerCalendar,
      ExplorerCard,
      MobileQUnitView,
      ExplorerDirectory,
      ExplorerDirectoryMobile,
      SidePanel,
      ExplorerCharts,
      QPagination,
    },
  
    data: () => ({
      
      current_view: null,
      apply_filters: new QFilters(),
      loading: false,
      qunits: null, // QUnitCollection
      view_props: {},

      clicked_qunit: null,

      filter_list: null,

      last_query: 0,
      
      source: null,
      CancelToken : axios.CancelToken,

      side_panel_items: [],
      selected: [],

      force_render: true,
      valid: true,
    }),
  
    
  
    computed: {
      ...mapState(['bpmap']),
      all_views(){
        return {
          'ExplorerTable': {
            text: this.$vuetify.lang.translator('views.table'),
            value: 'ExplorerTable',
            icon: 'mdi-format-list-checkbox',
          },
          'ExplorerCalendar': {
            text: this.$vuetify.lang.translator('views.calendar'),
            value: 'ExplorerCalendar',
            icon: 'mdi-calendar',
          },
          'ExplorerCard': {
            text: this.$vuetify.lang.translator('views.cards'),
            value: 'ExplorerCard',
            icon: 'mdi-view-stream',
          },
          'ExplorerCharts': {
            text: this.$vuetify.lang.translator('views.charts'),
            value: 'ExplorerCharts',
            icon: 'mdi-chart-bar',
          },
        }
      },
      bp_title() {
        return this.filters.get_filter_value('business_process')
          ? (this.bpmap.get_value(this.filters.get_filter_value('business_process')) || {}).name
          : (this.qunits || {}).bp_name || this.$vuetify.lang.translator('loading');
      },

      left_panel_items() {
        return this.side_panel_items.concat([
          this.is_mobile 
          ? {component: 'ExplorerDirectoryMobile',
             size: 'small',
             icon_size: 'large',}
          : {component: 'ExplorerDirectory'}
        ]);
     },
    },

    mounted() {
      if (this.views && this.views.length > 0 && !this.current_view) {
        this.change_view(this.views[0].name);
      }
      
      this.selected = this.items_to_select;
      
      this.valid = true;

      this.$nextTick(()=>{
        if (this.current_view && !this.state) {
          this.pull_filters();
          this.refresh();
        } else if (this.state) {
          this.import_state(this.state);
        }
      });
    },

    beforeDestroy() {
      this.valid = false;
      // Cancel previous query
      if (this.source) {
          this.source.cancel("Operation canceled by the user.");
        }
    },

    methods: {

      /* FILTERS */
      pull_filters() {
        this.apply_filters = new QFilters();
        
        this.apply_filters.set_filter(get_qfilter('exclude_states', false));
        this.apply_filters.set_filter(get_qfilter('sort_by', "current_workflow_limit"));
        this.apply_filters.set_filter(get_qfilter('sort_desc', false));

        this.apply_filters = this.apply_filters.merge(this.filters);

        this.qunits = null;
        if (this.filters.get_filter('pk')) {
          this.selected = [this.filters.get_filter_value('pk')];
        }
      },
      
      update_filters(ef) {
        this.apply_filters = this.apply_filters.merge(ef)

        this.$emit('update', this.apply_filters);

        this.$nextTick(()=> {
          this.refresh();
        });
      },

      all_filters(filters) {
        return new QFilters(this.filters).merge(filters);
      },

      /* QUNITS */
      qunit_clicked(unit){
        if (this.is_mobile && unit) {
          this.clicked_qunit = unit;
          this.$refs.qunit_view.open();
        }
      },
      clear_qunits() {
        this.qunits = null;
      },
      refresh() {
        if (!this.valid) {
          return ;
        }
        let query = (this.last_query + 1) % 10;
        this.last_query = query;

        
        
        // Cancel previous query
        if (this.source) {
          this.source.cancel("Operation canceled by the user.");
        }
        const filters = this.apply_filters.copy()
        this.source = this.CancelToken.source();
        
        if (this.view_props && this.view_props.function){
          //Loading
          this.loading = true;
          this.view_props.function(filters,this.source)
            .then(qc => {
              if (qc/*query == this.last_query*/) {
                this.qunits = qc; // QUnitCollection, para el ExplorerHeader
                let sort_by = this.apply_filters.get_filter_value('sort_by');
                if (!sort_by) {
                  sort_by = qc.columns.findIndex(it => it.value == "current_workflow_limit") > 0 
                              ? "current_workflow_limit" 
                              : (qc.columns[0] || {}).name
                  this.apply_filters.set_filter(get_qfilter('sort_by', sort_by))
                }
                this.apply_filters.set_filter(get_qfilter('page', qc.page), true)

                //this.apply_filters = new QFilters(this.apply_filters)

                this.$nextTick(()=>{
                  this.$emit('new_qunits',qc);
                })

              }
              this.loading = false;
            })
            .catch(err => {
              //console.error(err);
              if (query == this.last_query) {
                this.loading = false;
              }
            });
        }
      },

      update_qunit(new_qunit) {
        if (this.qunits) {
          this.qunits = this.qunits.replace_unit(new_qunit.uid, new_qunit);
        }
        this.clicked_qunit = new_qunit;
        this.selected = [new_qunit.uid];
        this.$emit('update_qunit',new_qunit);
      },

      goto_qunit(qunit) {
        if (this.view_props.navigate_function) {
          this.view_props.navigate_function(qunit);
        } else {
          Navegation.goto_qunit_by_uid(this.$router, qunit.uid,qunit.centro);
        }
      },

      /* QUNIT SELECTION */
      /* TODO: Finish and solve selection items from view component to GenericExplorer parent component */

      
      update_selection(selected) {
       this.selected = selected;
       this.$emit('update_selection',selected);
      },

      select_all(all) {
        this.$emit('select_all',all);
        if (all) {
          QUnit.getIds(this.apply_filters.copy()).then((res) => {
            this.update_selection(res)
          })
        } else {
          this.update_selection([]);
        }
      },
      

      /* VIEWS */
      avaible_views(views) {
        let exist_view = this.views.find(view => view.name === this.current_view);

        if (!exist_view && this.views.length > 0) {
          let view = this.is_mobile ? 'ExplorerCard' : this.views[0].name ;
          this.change_view(view);
        }

        return views.map(view => this.all_views[view.name]);
      },
      change_view(view) {
        if (view != this.current_view) {
          let current_func = this.view_props.function
          this.current_view = view;
          this.change_view_props();

          if (this.view_props.function != current_func){
            this.qunits = null;
            this.apply_filters.clear_tmp();
          }
        }
      },
      change_view_props() {
        let current_view_props = this.views.find(view => view.name === this.current_view);
        
        if (current_view_props) {
          this.view_props = current_view_props;
        }
      },
      update_props(props) {
        this.view_props = {...this.view_props, ...props};
      },

      /* FOOTER (PAGINATION) */
      change_page(pnum) {
        let filters = new QFilters();
        filters.set_filter(get_qfilter('page',pnum),true);
        
        this.update_filters(filters);
      },

      change_units_per_page(units) {
        let filters = new QFilters();
        filters.set_filter(get_qfilter('units_per_page',units));
        filters.set_filter(get_qfilter('page',1),true);

        this.update_filters(filters);
      },

      /* Explorer State */

      export_state() {
        let state = {
          'view': this.current_view,
          'units': this.qunits,
          'filters': this.apply_filters,
          'selected': this.selected,
        }
        if (this.loading) {
          return null;
        } else {
          return state;
        }
      },

      import_state(state) {
        this.change_view(state.view);
        this.qunits = state.units;
        this.apply_filters = state.filters;
        this.selected = state.selected;
      },
    },
  
    watch: {
      filters() {
        //let prev_filters = this.apply_filters;
        this.change_view(this.views[0].name)
        this.pull_filters();
        this.refresh();
        this.force_render = !this.force_render;
        //this.update_filters(this.filters);
      },
      views() {
        this.change_view_props();
      },
      items_to_select() {
        this.selected = [...this.items_to_select];
      },
    }
  }
</script>
